<div class="container flex f-fd--column-md padding-10">
  <div class="f-basis--6-lg f-basis--12">
    <h1 i18n="@@app.risk-map.evaluation.my-risks">Mis Riesgos</h1>
    <mat-tab-group>
      <mat-tab label="Selección de Riesgos">
        <howden-risks-steps></howden-risks-steps>
      </mat-tab>
      <mat-tab label="Riesgos Seleccionados">
        <howden-risks-selection></howden-risks-selection>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="f-basis--6-lg f-basis--12">
    <h1 i18n="@@app.risk-map.evaluation.risk-map">
      Mapa de Riesgos
      <button
        mat-icon-button
        color="primary"
        aria-label="helpRiskMap"
        title="Ayuda para la realización del mapa"
        (click)="helpRiskMap(false)"
      >
        <mat-icon>help</mat-icon>
      </button>
    </h1>
    <div class="flex">
      <div class="f-basis--12">
        <howden-risks-map></howden-risks-map>
      </div>
    </div>
    <div class="flex">
      <div class="f-basis--12 btn-container">
        <button
          mat-raised-button
          [disabled]="!newData"
          (click)="saveMapData()"
          i18n="@@app.risk-map.evaluation.save.ratings"
        >
          Guardar Valoraciones
        </button>
        <button
          mat-raised-button
          [disabled]="!childSteps.checkFullFlow()"
          (click)="downloadRiskReport()"
          i18n="@@app.risk-map.evaluation.download.report"
        >
          Descargar Informe
        </button>
      </div>
    </div>
  </div>
</div>
